<template>
<div id="shield">
  <div class="row">
    <Figure :figure-id="1" is-editable/>
    <Figure :figure-id="2" is-editable/>
    <Figure :figure-id="3" is-editable/>
    <Figure :figure-id="4" is-editable/>
    <Figure :figure-id="5"/>
    <Figure :figure-id="6"/>
    <Figure :figure-id="7"/>
    <Figure :figure-id="8"/>
  </div>
  <div class="row">
    <Figure :figure-id="9"/>
    <Figure :figure-id="10"/>
    <Figure :figure-id="11"/>
    <Figure :figure-id="12"/>
  </div>
  <div class="row">
    <Figure :figure-id="13"/>
    <Figure :figure-id="14"/>
  </div>
  <div class="row">
    <Figure :figure-id="15"/>
  </div>
  <div class="sentence">
    <Figure :figure-id="16" isBorderless/>
  </div>
</div>
</template>

<script>
import Figure from './Figure.vue'

export default {
  name: 'Shield',
  components: {
    Figure
  }
}
</script>

<style lang="scss" scoped>
#shield {
  position: relative;
}

.row {
  display: flex;
  flex-direction: row-reverse;
}

.sentence {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
